export type GeneratedId = `new-${number}`

export function generateId(): GeneratedId {
    return `new-${Math.random()}`;
}